// import { shadows } from '@indeed/ifl-tokens';
import { borderRadius } from '@indeed/ifl-tokens/react-native';
import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
    base: {
        padding: 4,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: 4,
        minHeight: 32,
    },
    withIcon: {
        minHeight: 'auto',
    },
    svgStyle: {
        marginLeft: -1,
        marginRight: -1,
    },
    wrapText: {
        // Removed fixed maxWidth to allow text to wrap naturally
        // The flexShrink: 1 and flexGrow: 0 in the Text component will handle wrapping
    },
    ml4: {
        marginLeft: 4,
    },
    mln4: {
        marginLeft: -4,
    },
    fullScreenVJSecondaryText: {
        fontWeight: 'bold',
        fontStyle: 'normal',
        flexShrink: 1,
    },
    fullScreenVJTextContainer: {
        flexShrink: 1,
        flexWrap: 'wrap',
        flexDirection: 'row',
        alignItems: 'center',
    },
    fullScreenVJChevronAutoMargin: {
        marginLeft: 'auto',
        flexShrink: 0,
    },
    fullScreenVJWrapper: {
        borderRadius: borderRadius.md,
        overflow: 'hidden',
    },
});
